import { getAppointmentHistory } from "@/services/booking";

const state = {
  appointmentHistories: null,
};

const getters = {
  appointmentHistories: (state) => state.appointmentHistories,
};

const actions = {
  async getAppointmentHistory({ commit }) {
    try {
      const response = await getAppointmentHistory();
      commit("getAppointmentHistory", response.data);
    } catch (error) {
      console.log(error);
    }
  },
  resetAppointmentHistory({ commit }) {
    commit("resetAppointmentHistory", null);
  }
};

const mutations = {
  getAppointmentHistory: (state, data) => (state.appointmentHistories = data),
  resetAppointmentHistory: (state, data) => (state.appointmentHistories = data),
};

export default { state, getters, actions, mutations };
